import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./fix-categories-button.module.scss";
import { font } from "@/util/fonts";
import { Button } from "@headlessui/react";
import { Icon } from "@/elements-react/fix-icon";

export interface FixCategoriesButtonProps {
  onClick?: React.MouseEventHandler<any>;
}

export const FixCategoriesButton: React.FC<FixCategoriesButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  // Вынесем стили для LG/Normal из util/fonts.ts
  const labelStyle: React.CSSProperties = {
    fontFamily: "var(--primary-font)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 380,
    lineHeight: "24px",
  };
  return (
    <div className={styles.root}>
      <Button className={classNames(styles.base)} onClick={onClick}>
        <span className={classNames(styles.label)} style={labelStyle}>
          {t("kgtqa204bgwxqctj.product-categories", "Product categories")}
        </span>
        <Icon name="down" className={styles.caret} width={16} />
      </Button>
    </div>
  );
};
